import { Card, Container, Grid } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import CurrencyRateTable from 'src/components/System/CurrencyRate/CurrencyRateTable';
import useLanguage from 'src/hooks/Language/useLanguage';
import BreakCrumbs from 'src/pages/Breakcum';
import { TBreadCrumb } from 'src/types/Breakcrumbs/breadcrumb.model';
import { PathURL } from 'src/utils/constants/path';

export default function CurrencyRate() {
  const { language } = useLanguage();
  const breadcrumb: TBreadCrumb[] = [
    { path: PathURL.dashboard, name: language.dashboard.titleHeader },
    { path: PathURL.system.currencyRate, name: 'Cài đặt tỷ giá' }
  ];

  return (
    <>
      <Helmet>
        <title>Cài đặt tỷ giá</title>
      </Helmet>

      <Container maxWidth="xl" className="pt-16">
        <Grid container direction="row" justifyContent="center" alignItems="stretch" spacing={3}>
          <Grid item xs={12} md={12}>
            {breadcrumb && <BreakCrumbs breadcrumb={breadcrumb} />}
          </Grid>
        </Grid>
        <Grid container direction="row" justifyContent="center" alignItems="stretch" spacing={3} className="pt-10">
          <Grid item xs={12}>
            <Card className="p-8">
              <CurrencyRateTable />
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
